module.exports = __webpack_public_path__ + "static/media/42_B.540591b9.png";